import * as Attention from './Attention/Attention.css';
import * as Tip from './Tip/Tip.css';
import * as MobileDialog from './MobileDialog/MobileDialog.css';
import * as Pagination from './Pagination/ui/Pagination.css';
import * as Tabs from './Tabs/ui/Tabs.css';
import * as IconTitle from './IconTitle/IconTitle.css';
import * as CdnIcon from './CdnIcon/ui/CdnIcon.css';
import * as FooterMobile from './FooterMobile/FooterMobile.css';
import * as Switch from './Switch/ui/Switch.css';
import * as QntBadge from './QntBadge/ui/QntBadge.css';
import * as Skeleton from './Skeleton/ui/Skeleton.css';
import * as ErrorModal from './ErrorModal/ui/ErrorModal.css';
import * as Filter from './Filter/ui/Filter.css';
import * as List from './List/ui/List.css';
import * as Restrictions from './Restrictions/ui/Restrictions.css';
import SegmentTabs from './SegmentTabs/ui/theme';
import * as CardExtraView from './CardExtraView/theme';
import FileUpload from './file-upload/theme';
export default {
    Attention,
    Tip,
    MobileDialog,
    Pagination,
    IconTitle,
    Tabs,
    CdnIcon,
    FooterMobile,
    Switch,
    QntBadge,
    Skeleton,
    ErrorModal,
    Filter,
    List,
    Restrictions,
    SegmentTabs,
    CardExtraView,
    FileUpload
};
